import { apiClient } from "./apiClient";

const BASE_URL = "/shopping";

/**
 * --- LISTS ---
 */

export async function fetchAllListsApi({ workspaceId, token }) {
  // Step 3 of test confirms endpoint: GET /shopping/workspace/:workspaceId
  return apiClient(`${BASE_URL}/workspace/${workspaceId}`, {
    token,
    method: "GET",
  });
}

export async function createListApi({ name, workspaceId, token }) {
  // Step 2 of test: Backend throws 400 if workspaceId is missing in the body
  if (!workspaceId) throw new Error("workspaceId is required");

  return apiClient(BASE_URL, {
    token,
    method: "POST",
    body: { name, workspaceId },
  });
}

// Single list fetch (Implicitly used in Step 6 to verify history/active items)
export async function fetchListByIdApi({ listId, token }) {
  return apiClient(`${BASE_URL}/${listId}`, {
    token,
    method: "GET",
  });
}

export async function getListApi({ listId, token }) {
  // Step 6 of test: GET /shopping/:listId
  return apiClient(`${BASE_URL}/${listId}`, {
    token,
    method: "GET",
  });
}

export async function renameListApi({ listId, name, token }) {
  return apiClient(`${BASE_URL}/${listId}`, {
    token,
    method: "PUT",
    body: { name },
  });
}

export async function deleteListApi({ listId, token }) {
  // Step 8 of test: Returns 204 No Content
  return apiClient(`${BASE_URL}/${listId}`, {
    token,
    method: "DELETE",
  });
}

/**
 * --- ITEMS ---
 */

export async function addItemApi({ listId, itemData, token }) {
  /**
   * Step 4 & 5 update:
   * itemData can now include:
   * { name: string, propertiesDescription?: string, quantity?: number, unit?: string }
   */
  return apiClient(`${BASE_URL}/${listId}/items`, {
    token,
    method: "POST",
    body: itemData,
  });
}

export async function addBatchItemsApi({ listId, items, token }) {
  return apiClient(`${BASE_URL}/${listId}/items/batch`, {
    token,
    method: "POST",
    body: { items },
  });
}

export async function updateItemApi({ listId, itemId, itemData, token }) {
  return apiClient(`${BASE_URL}/${listId}/items/${itemId}`, {
    token,
    method: "PUT",
    body: itemData,
  });
}

export async function markPurchasedApi({ listId, itemId, token }) {
  // Step 6: PUT request that moves item to history. Returns 204.
  return apiClient(`${BASE_URL}/${listId}/items/${itemId}/purchase`, {
    token,
    method: "PUT",
  });
}

/**
 * --- SUGGESTIONS ---
 */

export async function fetchSuggestionsApi({ listId, token }) {
  // Step 7: Verifies suggestions based on purchased items
  return apiClient(`${BASE_URL}/${listId}/suggestions`, {
    token,
    method: "GET",
  });
}

export async function fetchRecentlyUsedApi({ listId, token }) {
  // Uses the new backend endpoint for recently used items
  return apiClient(`${BASE_URL}/${listId}/recentlyUsed`, {
    token,
    method: "GET",
  });
}

export async function fetchHistoryApi({ listId, token }) {
  return apiClient(`${BASE_URL}/${listId}/history`, {
    token,
    method: "GET",
  });
}

export async function fetchWorkspaceHistoryApi({ workspaceId, token }) {
  return apiClient(`${BASE_URL}/workspace/${workspaceId}/history`, {
    token,
    method: "GET",
  });
}